function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.6 20h-3.2",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M17 10.032V10v0a5 5 0 00-5-5v0a5 5 0 00-5 5v2.504a.855.855 0 01-.472.764l-.503.251A1.857 1.857 0 005 15.178v0c0 1.024.83 1.854 1.854 1.854h10.292c1.024 0 1.854-.83 1.854-1.854v0c0-.702-.397-1.344-1.025-1.658l-.503-.251a.857.857 0 01-.472-.765v-2.472z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.95 6.05a8.029 8.029 0 00-3-3M5.05 6.05a8.029 8.029 0 013-3",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgNotification;